import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  UrlTree,
} from '@angular/router';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { Observable, of, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private authStorage: OAuthStorage
  ) { }

  canActivate(route: ActivatedRouteSnapshot):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    let res = this.hasPrivilages(route.data.role);
    return res;
  }

  hasPrivilages(role: string): Observable<boolean | UrlTree> {
    let claims = JSON.parse(this.authStorage.getItem('id_token_claims_obj'));
    if(claims === null){
      timer(100)
            .toPromise()
            .then(() => {
              this.hasPrivilages(role);
            });
    }

    let roles: Array<string> = claims.role;

    if(role.includes(";")){
      let rol: string[] = role.split(";");

      let res = false;
      for (var i = 0, len = roles.length; i < len; i++) {
        if(roles[i].valueOf() === "super_admin"){
          res = true;
          break;
        } else{
          for(var j = 0, l = rol.length; j < l; j++){
            if (roles[i].valueOf() === rol[j].trim()) {
              res = true;
              break;
            }
          }
        }
      }

      return of(res);
    }else{
      let res = false;
      for (var i = 0, len = roles.length; i < len; i++) {
        if(roles[i].valueOf() === "super_admin" || roles[i].valueOf() === role){
          res = true;
          break;
        }
      }

      return of(res);
    }
  }
}
